module.exports = __webpack_public_path__ + "static/media/finches1.029ce0bb.jpg";